import { useMemo } from 'react';

import useMartyContext from 'hooks/useMartyContext';
import SponsoredAdsProduct from 'components/search/SponsoredAdsProduct';
import { getLowStockLabelStatus } from 'helpers/cardUtils';

const SponsoredAdsWrapper = ({
  sponsoredAds,
  msaImageParams,
  trackSponsoredAdImpressions,
  makeSponsoredAdClick,
  numSponsoredAds,
  sponsoredAdsToShow,
  CardBottomSlot = null
}) => {
  const {
    marketplace: {
      search: { hasStyleRoomFlag }
    }
  } = useMartyContext();

  const products = useMemo(
    () =>
      sponsoredAds.results?.map((product, i) => ({
        ...product,
        index: i,
        isSponsored: true
      })),
    [sponsoredAds.results]
  );

  if (!sponsoredAdsToShow) {
    return null;
  }

  return sponsoredAds.results.map((_props, i) => {
    const product = products[i];
    const { styleId, colorId } = product;
    product.isLowStock = getLowStockLabelStatus({
      ...product,
      hasStyleRoomFlag
    });

    return (
      styleId &&
      colorId && (
        <SponsoredAdsProduct
          key={`${styleId}-${colorId}`}
          product={product}
          numSponsoredAds={numSponsoredAds}
          trackSponsoredAdImpressions={trackSponsoredAdImpressions}
          makeSponsoredAdClick={makeSponsoredAdClick}
          msaImageParams={msaImageParams}
          CardBottomSlot={CardBottomSlot}
        />
      )
    );
  });
};

export default SponsoredAdsWrapper;
